<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="ListsOverview")
    h1.title Alle Rechnungen
    .sub-headline Hier sehen Sie alle Rechnungen in chronologischer Reihenfolge. Bei einer Steuerprüfung können Sie hier alle Rechnungen einsehen und die lückenlose Dokumentation sicherstellen.
    .spacer.sm
    .sub-headline Das System hat gerade eine Lückenprüfung durchgeführt und festgestellt, dass die Rechnungsnummern lückenlos sind: {{ isGapless ? '✅ Ja, lückenlos' : '🚨 Nein, bitte prüfen' }}
  .card.margin-top
    //- .top
    //-   .spacer.sm
    //-   .button-wrapper
    //-     b-field(label="Rechnungsnummer" label-position="on-border")
    //-       b-input(v-model="filter.invoiceNr")
    .main
      b-table(:data="tableData"
              default-sort-direction="desc"
              default-sort="invoiceNr"
              hoverable
              @click="row => jumpToBookingInCalendar(row)")
        b-table-column(field='invoiceNr' label='Rechnungs-Nr.' sortable v-slot="props")
          | \#{{props.row.invoiceNr}}
        b-table-column(field='status' label='Status' sortable v-slot="props")
          b-tag(v-if="props.row.status === 'Unterschrieben'" type="is-success" size="is-small") {{props.row.status}}
          b-tag(v-else-if="props.row.status === 'Nicht unterschrieben'" type="is-warning" size="is-small") {{props.row.status}}
          b-tag(v-else-if="props.row.status === 'Unterschrieben & storniert'" type="is-danger" size="is-small") {{props.row.status}}
        b-table-column(field='downloadLink' label='Download' sortable v-slot="props")
          b-button(v-if="props.row.downloadLink" @click="openPDF(props.row.downloadLink)" size="is-small") Öffnen
        b-table-column(field='createdAt' label='erstellt am' sortable v-slot="props")
          | {{ props.row.createdAt }}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      isGapless: true,
      invoices: [],
      tableData: [],
      filter: {
        invoiceNr: null,
      }
    };
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.invoices = await this.$store.dispatch("parentContracts/getAll");
    this.transformTableData();
    loadingComponent.close();
  },
  methods: {
    async openPDF(contractId) {
      const newFile = await this.$store.dispatch('contracts/getAttachement', {id: contractId});
      const file = new Blob([newFile], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    transformTableData() {
      let lastNr = 0;
      for (const invoice of this.invoices) {
        if (invoice.id - lastNr > 1 && lastNr !== 0) {
          console.log('gap detected: ', lastNr, invoice.id);
          this.isGapless = false;
        }

        const isSigned = invoice.rentObjectBooking ? !!invoice.rentObjectBooking.signedContractId : false;
        const hasCancelInvoices = invoice.rentObjectBooking && invoice.rentObjectBooking.cancelInvoices && invoice.rentObjectBooking.cancelInvoices.length > 0;
        const signedContractId = invoice.rentObjectBooking ? invoice.rentObjectBooking.signedContractId : null;
        const lastContractId = invoice.contracts ? invoice.contracts.sort((a, b) => b.id - a.id)[0].id : null;

        this.tableData.push({
          invoiceNr: invoice.id,
          createdAt: this.formatDate(invoice.createdAt),
          downloadLink: signedContractId || lastContractId,
          status: isSigned ? hasCancelInvoices ? 'Unterschrieben & storniert' : 'Unterschrieben' : 'Nicht unterschrieben',
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-text {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.extra-table {
  font-size: 0.8rem;

  td {
    padding: 0;
  }
}

.status-selection {
  display: inline-block;
  font-size: 14px;
  margin-right: 4px;
  font-weight: 500;
  user-select: none;
  text-align: left;
  color: black !important;

  .color-box {
    height: 16px;
    width: 24px;
    border-radius: 99px;
    display: inline-block;
    margin-right: 3px;
  }
}
</style>